module.exports = __webpack_public_path__ + "static/media/bargaining.745538df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bargaining.jpg
// module id = 247
// module chunks = 0